import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UNITS } from 'src/app/shared/pipe/translation.pipe/translation.pipe';
import { CostElement } from '../model/cost-element';

@Component({
  selector: 'app-cost-element-form',
  templateUrl: './cost-element-form.component.html',
  styleUrls: ['./cost-element-form.component.scss']
})
export class CostElementFormComponent implements OnInit {

  @Input()
  element: CostElement;

  @Output()
  elementChange = new EventEmitter<CostElement>();

  formGroup: FormGroup;

  UNITS = UNITS;

  constructor(
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      cost: [this.element.cost, [Validators.required, Validators.min(0)]],
      installation_cost: [this.element.installation_cost, [Validators.required, Validators.min(0)]]
    });
  }

  save() {
    const { value } = this.formGroup;

    const cost = {
      ...this.element,
      cost: Number(value.cost),
      installation_cost: Number(value.installation_cost)
    } as CostElement;
    this.elementChange.emit(cost);
  }
}

